import React from 'react';
import { MemoryRouter, Redirect, Route, Switch } from 'react-router-dom';
import ActionButton from '../components/ActionButton';
import FilterComponent from '../components/FilterComponent';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import { useApp } from '../context/AppContext';
import About from '../pages/About';
import Emotions from '../pages/Emotions';
import Geography from '../pages/Geography';
import Home from '../pages/Home';
import Leaderboard from '../pages/Leaderboard';
import Predictions from '../pages/Predictions';
import Scoreboards from '../pages/Scoreboards';
import Selections from '../pages/Selections';
import Whatif from '../pages/Whatif';
import { Overlay } from './styles';

const Routes: React.FC = () => {

  const {showFilter} = useApp()

  return (
    <MemoryRouter>
      <FilterComponent />
      <Menu />
      <Overlay isOpen={showFilter}/>
      <ActionButton />
      <Switch>
        <Redirect exact from="/" to={`/home`} />
        <Route path="/home" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/leaderboard" component={Leaderboard} />
        <Route path="/scoreboards" component={Scoreboards} />
        <Route path="/selections" component={Selections} />
        <Route path="/geography" component={Geography} />
        <Route path="/whatif" component={Whatif} />
        <Route path="/predictions" component={Predictions} />
        <Route path="/emotions" component={Emotions} />
      </Switch>
      <Footer />
    </MemoryRouter>
  );
};

export default Routes;
